import cn from 'classnames';
import React from 'react';
import { FormattedMessage as Message } from 'react-intl';
import { ThemedButton } from 'src/templates/webview/ThemedButton';
import { getUrlParam } from '../../utils/get-url-param';
import styles from './Passed.module.css';

const Passed: React.FC<{ isWebview: boolean; onClose: VoidFunction }> = ({ isWebview, onClose }) => {
  const heightGrow = getUrlParam('height_grow') !== 'off';
  const rootStyle = { height: heightGrow ? '100%' : 'auto', transition: 'height 5s ease-out' };

  return (
    <div id="content" style={rootStyle}>
      <div className={cn(styles.root, isWebview && styles.webview)}>
        <div className={styles.icon} />

        <div className={styles.text}>
          <Message id={'System.AlreadyTakenTheSurvey'} />
        </div>

        {isWebview && (
          <div className={styles.button}>
            <ThemedButton appearance="secondary" onClick={onClose}>
              <Message id="System.SignOut" />
            </ThemedButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default Passed;
